module.exports = __webpack_public_path__ + "static/media/master.7570bc49.svg";